export default __webpack_public_path__ + "static/media/65.6dfadb1f.png";